import dropdownStateSelector from './dropdownStateSelector';
import { CARRIER } from '../../constants';

function flowAlreadyCompleted(dropdownState) {
    const {
        carrier,
        plan,
    } = dropdownState;

    const hasCarrier = carrier;
    const hasNonInsuranceOption = hasCarrier && carrier.id < 0;
    const hasPlan = plan;

    return hasCarrier && (hasPlan || hasNonInsuranceOption);
}

function shouldShowSearch(dropdownState) {
    return !!((dropdownState.searchItems && dropdownState.typedValue)
        || (dropdownState.typedValue && dropdownState.typedValue.length > 0));
}

function shouldShowChange({ dropdownState, flowCompleted, showSearch }) {
    return dropdownState.isOpen && flowCompleted && !showSearch;
}

function userHasInteracted(state) {
    const {
        carrier,
        plan,
        hasBeenOpened,
    } = state;

    // eslint-disable-next-line eqeqeq
    return (hasBeenOpened || carrier || plan);
}

function shouldShowErrorState({ dropdownState, flowCompleted }) {
    return !dropdownState.isOpen
        && userHasInteracted(dropdownState)
        && !flowCompleted;
}

function isPlanDisabled({ dropdownState }) {
    return !dropdownState.carrier
        || dropdownState.carrier.id < 0
        || dropdownState.carrier.id === CARRIER.BLUE_CROSS_BLUE_SHIELD;
}

export function getDropdownState(state) {
    const dropdownState = dropdownStateSelector(state);
    const flowCompleted = !!flowAlreadyCompleted(dropdownState);
    const showSearch = shouldShowSearch(dropdownState);
    const showChange = shouldShowChange({
        dropdownState,
        showSearch,
        flowCompleted,
    });
    const showErrorState = !!shouldShowErrorState({
        dropdownState,
        flowCompleted,
    });
    const planDisabled = isPlanDisabled({ dropdownState });
    const { showScanInsuranceCardButton } = dropdownState;

    return {
        ...dropdownState,
        flowCompleted,
        showSearch,
        showChange,
        showErrorState,
        planDisabled,
        showScanInsuranceCardButton,
    };
}
